import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DoubleRightIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#3379BD"
      d="M13.697 4.47a.75.75 0 0 0-1.06 1.06l1.06-1.06Zm6.47 7.53.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-7.53 6.47a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm-7.107-14a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM12 12l.53.53a.75.75 0 0 0 0-1.06L12 12Zm-7.53 6.47a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm8.166-12.94 7 7 1.061-1.06-7-7-1.06 1.06Zm7 5.94-7 7 1.06 1.06 7.001-7-1.06-1.06ZM4.47 5.53l7 7 1.06-1.06-7-7-1.06 1.06Zm7 5.94-7 7 1.06 1.06 7-7-1.06-1.06Z"
    />
  </Svg>
);
export default DoubleRightIcon;
